import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimRemoveActsKC2Gql } from '../../BimWorkOrderPriceTable/bimWorkOrderPriceQueries';

const requestId = 'bimRemoveActsKC2';

export const useBimRemoveActsKc2 = (workOrderPriceId: number, onSuccess: () => void) => {
    const dispatch = useDispatch();

    const [bimRemoveActsKc2Reset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        bimRemoveActsKc2Reset(undefined);

        onSuccess();
    }, [bimRemoveActsKc2Reset, onSuccess]);

    const [bimRemoveActsKc2Data, bimRemoveActsKc2Status, bimRemoveActsKc2Error, bimRemoveActsKc2Request] = useRequest({
        requestId,
        query: bimRemoveActsKC2Gql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const bimRemoveActsKc2MakeRequest = useCallback(
        (actKC2Ids: number[]) => {
            dispatch(bimRemoveActsKc2Request({ workOrderPriceId, actKC2Ids }));
        },
        [bimRemoveActsKc2Request, dispatch, workOrderPriceId],
    );

    useEffect(() => {
        bimRemoveActsKc2Reset(undefined);
    }, [bimRemoveActsKc2Reset]);

    return {
        bimRemoveActsKc2MakeRequest,
        bimRemoveActsKc2Data,
        bimRemoveActsKc2Status,
        bimRemoveActsKc2Error,
    };
};
